import { ActionProps } from "./types";
import SinglePayment from "./payments/SinglePayment";
import { ManageLeverageProvider } from "./payments";

export default function MakeRepayment({ loanExpanded, loopPosition }: ActionProps) {
    return (
        <ManageLeverageProvider loanExpanded={loanExpanded} loopPosition={loopPosition} isRepayContext={true}>
            <SinglePayment loanExpanded={loanExpanded} />
        </ManageLeverageProvider>
    );
}
